import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { X } from "lucide-react";
import { Card } from "src/components/ui/card";
import { Button } from "src/components/ui/button";
import { set_close_appointment_dialog } from "src/config/redux/slicer/dialog/appointmentDialogSlicer";
import { getCurrentUserLocation } from "src/lib/utils";
import { DEFAULT_COORDS } from "src/config/services/fellas/google.api";
import LeafletMapView from "src/components/map/LeafletMapView";
import { currentLocationIcon } from "src/components/map/fellasIcon";

interface DialogLocationRouteProps {
  is_offline_patient?: boolean;
}

function DialogLocationRoute({ is_offline_patient }: DialogLocationRouteProps) {
  const dispatch = useDispatch();
  const { selected_appointment } = useSelector((state: any) => state.AppointmentDialog);
  const [current_coords, setCurrentCoords] = useState<{ lat: number; lng: number } | null>(null);

  const target_coords = is_offline_patient
    ? selected_appointment?.health_care?.offline_location?.coords
    : selected_appointment?.homecare?.user_location?.coords;

  const homecare_area = selected_appointment?.health_care?.homecare_area || {};
  const { radius = 5, coords: hc_coords } = homecare_area;

  const validTargetCoords = target_coords && typeof target_coords.lat === 'number' && typeof target_coords.lng === 'number'
    ? target_coords
    : DEFAULT_COORDS;

  const user_lat = validTargetCoords.lat;
  const user_lng = validTargetCoords.lng;
  const current_lat = current_coords?.lat ?? user_lat;
  const current_lng = current_coords?.lng ?? user_lng;

  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${current_lat},${current_lng}&destination=${user_lat},${user_lng}`;

  const onClose = () => {
    dispatch(set_close_appointment_dialog('homecare_location'));
    dispatch(set_close_appointment_dialog('appointment_location'));
  };

  useEffect(() => {
    getCurrentUserLocation().then((location: any) => {
      if (location?.coords) {
        setCurrentCoords(location.coords);
      }
    });
  }, []);

  return (
    <div className="fixed top-0 left-0 z-50 h-screen w-screen bg-black/50 flex items-center justify-center p-4">
      <Card className="shadow-lg w-full max-w-[600px] p-6 space-y-4 bg-white rounded-lg">
        <div className="flex justify-between items-center">
          <p className="text-lg font-semibold text-gray-800">
            {is_offline_patient ? 'Lokasi Layanan Offline' : 'Lokasi Pasien'}
          </p>
          <X onClick={onClose} className="hover:stroke-red-500 cursor-pointer w-5 h-5 text-gray-500" />
        </div>

        <div className="h-64 rounded-sm overflow-hidden border border-gray-200">
          <LeafletMapView
            center={validTargetCoords}
            zoom={14}
            markerPosition={validTargetCoords}
            draggable={false}
            circle={
              !is_offline_patient && hc_coords
                ? {
                    center: hc_coords,
                    radius: radius,
                  }
                : null
            }
            secondaryMarker={
              current_coords
                ? {
                    position: current_coords,
                    icon: currentLocationIcon,
                  }
                : null
            }
          />
        </div>

        <Button
          variant="outline"
          className="w-full text-primary hover:text-primary hover:bg-pink-50 border-pink-200"
          onClick={() => window.open(googleMapsUrl, '_blank')}
        >
          Buka Rute Navigasi di Google Maps
        </Button>
      </Card>
    </div>
  );
}

export default DialogLocationRoute;
